function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Text } from '@naf/text';
import React, { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { animation } from '@naf/theme';
export const AnimateText = ({
  children,
  delay,
  timeout = animation.uiSpeed,
  textProps = {},
  className
}) => {
  const ref = useRef(null);
  const [inProp, setInProp] = React.useState(false);
  useEffect(() => {
    if (delay) {
      setTimeout(() => {
        setInProp(true);
      }, delay);
    } else {
      setInProp(true);
    }
  }, [delay]);
  return /*#__PURE__*/React.createElement(HideOverflow, null, /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: ref,
    timeout: timeout,
    in: inProp,
    classNames: "node"
  }, /*#__PURE__*/React.createElement(AnimatedText, _extends({
    ref: ref,
    timeout: timeout
  }, textProps, {
    className: className
  }), children)));
};
const AnimatedText = styled(Text).withConfig({
  displayName: "AnimateText__AnimatedText",
  componentId: "sc-1548k6m-0"
})(["transform:translateY(108%);&.node-enter-active,&.node-enter-done{transform:translateY(0);transition:", "ms ", ";}"], ({
  timeout
}) => timeout, animation.easeIn);
const HideOverflow = styled.div.withConfig({
  displayName: "AnimateText__HideOverflow",
  componentId: "sc-1548k6m-1"
})(["clip-path:inset(0 0 -8% 0);"]);
//# sourceMappingURL=AnimateText.js.map